module.exports = __webpack_public_path__ + "img/The_Sandbox_Characters.07e77393.png";